import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import {SubscriptionTransferRequestSummary, SubscriptionTransferRequest, SubscriptionTransferProps} from "models/subscription-transfer";

export class SubscriptionTransferRequestService {
  /** Fetches every subscription transfer request for the selected month (no UI cap). */
  async getSubscriptionTransferRequestsByMonth(
    yearMonth?: string,
  ): Promise<SubscriptionTransferRequestSummary[]> {
    const queryParams = new URLSearchParams();
    if (yearMonth) {
      queryParams.append("yearMonth", yearMonth);
    }
    const response = await fetch(
      `${API_URL}/subscription-transfer?${queryParams.toString()}`,
    );
    const data = await checkResponse(response);
    const parsed = data as { data?: SubscriptionTransferRequestSummary[] };
    return parsed.data ?? [];
  }

  async getSubscriptionTransferRequestById(id: string): Promise<SubscriptionTransferRequest> {
    const response = await fetch(`${API_URL}/subscription-transfer/${id}`);
    const data = await checkResponse(response);
    return data as SubscriptionTransferRequest;
  }

  async createSubscriptionTransferRequest(
    requestData: SubscriptionTransferProps
  ): Promise<SubscriptionTransferRequest> {
    const response = await fetch(`${API_URL}/subscription-transfer`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });
    const data = await checkResponse(response);
    return data as SubscriptionTransferRequest;
  }
}
